import { UploadLinkCodeRejectionReason } from 'src/app/_models/upload-link-code-rejection';

export const WRONG_PASSWORD_ERROR =
  'Falsches Passwort. Bitte versuchen Sie es erneut oder fordern Sie ein neues Passwort an.';
export const UNEXPECTED_ERROR = 'Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.';
export const EXPIRED_REJECTION_REASONS = [
  UploadLinkCodeRejectionReason.Inactive,
  UploadLinkCodeRejectionReason.Expired,
];
